import { Box, Button, CardMedia, Typography, useMediaQuery, useTheme } from "@mui/material";
import { ReactComponent as GreaterThan } from "assets/Icons/GreaterThan.svg";
import TextAnimation from "components/TextAnimation/TextAnimation";
import content from "content/HeroSection";
import React from "react";
import { useNavigate } from "react-router-dom";

export default function HeroSection() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();
  const handleStartButton = () => {
    navigate("/contact");
  };
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: { xs: "90px", sm: "95px", md: "70px", lg: "85px", xl: "109px" },
        alignSelf: "stretch",
        padding: "0px 0px  20px 0px",
      }}
    >
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "12px",
        }}
      >
        <Typography
          sx={{
            width: "100%",
            color: "#FF6039",
            fontSize: { xs: "33px", sm: "38px", md: "64px" },
            fontWeight: { xs: 600, md: 700 },
            lineHeight: 1.4,
            textAlign: "center",
            display: "inline",
          }}
        >
          {content.main.heading}
          <span
            style={{
              marginLeft: "0.5ch",
              display: "inline-flex",
              justifyContent: "center",
              alignItems: "center",
              flexShrink: 0,
              color: "#3698BF",
              verticalAlign: "middle",
            }}
          >
            <TextAnimation />
          </span>
        </Typography>
        <Box
          sx={{
            width: "70%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "48px",
            alignSelf: "stretch",
            margin: "auto",
            padding: 1,
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: "16px", sm: "19px", md: "23px" },
              alignSelf: "stretch",
              fontWeight: { xs: 400, sm: 400, md: 500 },
              lineHeight: 1.4,
              color: "#555B5D",
              textAlign: "center",
            }}
          >
            {content.main.description}
          </Typography>

          <Button
            variant="contained"
            endIcon={<GreaterThan />}
            sx={{
              height: { xs: "64px", sm: "56px", md: "56px" },
              padding: "10px 20px 10px 30px",
              justifyContent: "center",
              borderRadius: "30px",
              border: "2px solid #FFF",
              background: `linear-gradient(180deg, #0E0E0E 0%, #333 100%)`,
              boxShadow: "0px 14px 30px 0px rgba(0, 0, 0, 0.12)",
              fontWeight: 600,
            }}
            onClick={handleStartButton}
          >
            <Typography
              sx={{
                color: "#FFF",
                fontFamily: "Inter",
                fontSize: "16px",
                fontWeight: 600,
                lineHeight: 1.4,
                textTransform: "capitalize",
              }}
            >
              {content.main.button}
            </Typography>
          </Button>
        </Box>
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: { xs: "column", sm: "row", md: "row" },
          alignItems: "center",
          alignSelf: "stretch",
          justifyContent: "canter",
          alignContent: { xs: "center", sm: "center", md: "center" },
          gap: { xs: "20px 32px", sm: "0px", md: "32px" },
          flex: { xs: "0 0 1", sm: "0 0 1", md: "1 0 0" },
          flexWrap: { xs: "wrap", sm: "nowrap", md: "warp" },
        }}
      >
        {content.main.animatedData.map((item) => (
          <Box
            key={item.id}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: "24px",

              padding: {
                xs: "10px 12px",
                sm: "20px 12px",
                md: "20px",
              },
              width: {
                xs: "228px", // Mobile
                sm: "285px", // Tablet
                md: "262px",
              },
              height: {
                xs: "64px", // Mobile
                sm: "72px", // Tablet
                md: "94px",
              },
              borderRadius: "200px",
              border: "4.159px solid #FFF",
              background: "#C1DFEB",
              boxShadow: "0px 14px 30px 0px rgba(0, 0, 0, 0.12)",
              flex: { xs: "0 0 1", sm: "0 0 1", md: "1 0 0" },
            }}
          >
            <Box
              sx={{
                // width: {
                //   xs: "36px",
                //   sm: "45px",
                //   md: "56px",
                // },
                height: {
                  xs: "36px",
                  sm: "45px",
                  md: "56px",
                },
              }}
            >
              <CardMedia
                component="img"
                image={item.icon}
                alt={item.id}
                sx={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "flex-start",
                flexShrink: 0,
              }}
            >
              <Typography
                sx={{
                  color: "#555B5D",
                  fontFamily: "Inter",
                  fontSize: { xs: "16px", sm: "23px", md: "28px" },
                  fontWeight: 600,
                  lineHeight: 1.4,
                }}
              >
                {item.title}
              </Typography>
              <Typography
                sx={{
                  color: "#555B5D",
                  fontFamily: "Inter",
                  fontSize: { xs: "13px", sm: "16px", md: "19px" },
                  fontWeight: 400,
                  lineHeight: 1.4,
                }}
              >
                {item.subtitle}
              </Typography>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
